import { render, staticRenderFns } from "./WebPartHotProductsDesigner.vue?vue&type=template&id=c9e1fd86&scoped=true&"
import script from "./WebPartHotProductsDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartHotProductsDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartHotProductsDesigner.vue?vue&type=style&index=0&id=c9e1fd86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e1fd86",
  null
  
)

export default component.exports